/** @jsx jsx */
import { jsx } from "theme-ui"

const SectionWrapper = props => {
  return (
    <section
      sx={{
        backgroundColor: props.bg || "inherit",
        backgroundImage: "none",
        px: 3,
        py: 2,
        width: "100vw",
        position: "relative",
        left: "calc(-50vw + 50%)",
      }}
      id={props.id}
    >
      {props.children}
    </section>
  )
}

export default SectionWrapper
